import {AxiosError, AxiosResponse} from 'axios';

import {logAxiosError} from '@zzng/common/utils/axiosInterceptor';
import {setSentryErrorLevel} from '@zzng/common/utils/matrix';

export const logResponseError = (error: AxiosResponse) => {
  if (error instanceof AxiosError) {
    logAxiosError(error);
    setSentryErrorLevel(error);
  }
  return Promise.reject(error);
};
